import React from "react";

//Components
import EtaTable from '../etaTable'
const EtaScheduled = (props) => {

    return (
        <div>
            <EtaTable {...props} />
        </div>
    )
}

export default EtaScheduled